import React from 'react';

import styles from '../../../../utils/styles';
import { TypographyElements } from '../../../foundation';

import './Category.scss';

export type CategoryType = 'adv' | 'category';

export interface ICategory {
  type: CategoryType;
  text?: string;
}

export const textMapping = Object.freeze({
  adv: 'ANNUNCIO',
});

const Category: React.FC<ICategory> = ({ text, type }) => {
  return (
    <div className={styles('category', type === 'adv' && `category--${type}`)}>
      <TypographyElements
        text={textMapping[type] ?? text?.replaceAll('-', ' ').toUpperCase()}
        typographyClass="ty-elements-medium--uppercase"
      />
    </div>
  );
};

export default Category;
